import Vue from 'vue'
import VueRouter from 'vue-router'
import mainLayout from '../views/layout/mainLayout.vue'

Vue.use(VueRouter)

const routes = [{
	path: '/',
	component: mainLayout,
	children: [{
		path: '/',
		name: 'home',
		component: () => import( /* webpackChunkName: "home" */ '../views/home.vue'),
		meta: {
			title: 'HOME'
		}
	}, {
		path: '/products',
		name: 'products',
		component: () => import( /* webpackChunkName: "products" */ '../views/products.vue'),
		meta: {
			title: 'PRODUCTS'
		}
	}, {
		path: '/productDetails',
		name: 'productDetails',
		component: () => import( /* webpackChunkName: "products" */ '../views/productDetails.vue')
	}, {
		path: '/sparesQuery',
		name: 'sparesQuery',
		component: () => import( /* webpackChunkName: "sparesQuery" */ '../views/sparesQuery.vue'),
		meta: {
			title: 'SPARES QUERY'
		}
	}, {
		path: '/service',
		name: 'service',
		component: () => import( /* webpackChunkName: "service" */ '../views/service.vue'),
		meta: {
			title: 'SERVICE'
		}
	}, {
		path: '/contactUs',
		name: 'contactUs',
		component: () => import( /* webpackChunkName: "contactUs" */ '../views/contactUs.vue'),
		meta: {
			title: 'CONTACT US'
		}
	}]
},
{
	path: '/login',
	name: 'accountLayout',
	component: () => import(/* webpackChunkName: "accountLayout" */ '../views/layout/accountLayout.vue'),
	children: [{
		path: '/login',
		name: 'login',
		component: () => import( /* webpackChunkName: "login" */ '../views/account/login.vue')
	}, {
		path: '/register',
		name: 'register',
		component: () => import( /* webpackChunkName: "register" */ '../views/account/register.vue')
	}, {
		path: '/passwordChange',
		name: 'passwordChange',
		component: () => import( /* webpackChunkName: "passwordChange" */ '../views/account/passwordChange.vue')
	}]
}
]

const router = new VueRouter({
	routes
})

export default router
